import { IntakeWorkflowRuleTypeSchema } from "@src/sudozi-schemas/get-intake-submission-approval-status.schema";
import { z } from "zod";

export const Thread = z.object({
  id: z.string(),
  createdAt: z.string(),
  thread: z.object({
    id: z.string(),
    createdAt: z.string(),
    resolvedAt: z.string().nullable(),
    resolvedByUser: z
      .object({
        id: z.string(),
        firstName: z.string(),
        lastName: z.string(),
        email: z.string(),
      })
      .nullable(),
    company: z.object({ id: z.string(), name: z.string() }),
    vendorCompany: z.object({ id: z.string(), name: z.string() }).nullable(),
  }),
});

export const GetIntakeSubmissionThreadsOutput = Thread.merge(
  z.object({
    company: z.object({ id: z.string(), name: z.string() }),
    vendorCompany: z.object({ id: z.string(), name: z.string() }).nullable(),
    vendor: z.object({ id: z.string(), name: z.string() }).nullable(),
    intakeSubmissionAnswer: z
      .object({
        intakeQuestionLabel: z.string(),
      })
      .nullable(),
  }),
);

export type GetIntakeSubmissionThreadsOutput = z.infer<
  typeof GetIntakeSubmissionThreadsOutput
>;

export const GetLevelGroupStatusThreads = Thread.merge(
  z.object({
    intakeSubmission: z.object({ id: z.string() }),
    levelGroupStatus: z.object({
      id: z.string(),
      label: z.string(),
      ruleType: IntakeWorkflowRuleTypeSchema,
      group: z.object({ id: z.string(), description: z.string() }).nullable(),
      task: z.object({ id: z.string(), description: z.string() }).nullable(),
      sendVendorFormTask: z
        .object({ id: z.string(), description: z.string() })
        .nullable(),
      sendDocumentTask: z.object({ id: z.string() }).nullable(),
      netsuitePurchaseOrder: z
        .object({ id: z.string(), description: z.string() })
        .nullable(),
      startIroncladWorkflow: z
        .object({ id: z.string(), description: z.string() })
        .nullable(),
      additionalStepTask: z.object({ id: z.string() }).nullable(),
      middeskBusinessVerificationTask: z
        .object({ id: z.string(), description: z.string() })
        .nullable(),
    }),
  }),
);

export type GetLevelGroupStatusThreads = z.infer<
  typeof GetLevelGroupStatusThreads
>;
